import BaseModel from '../core/BaseModel';

export default class NewsProductModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'news_product',
        tableName: 'news_product',
        label: 'News Product',
      },
      {
        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        news_id: {
          name: 'news_id',
          label: 'News',
          type: 'String',
          display: false,
        },
        
        obj_id: {
          name: 'obj_id',
          label: 'Car',
          type: 'String',
          display: false,
        },

        created_at: {
          name: 'created_at',
          type: 'Datetime',
          label: 'Created At',
          display: false,
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          display: false,
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },
      }
    );
  }
}
